/**
 * Centralized, framework-agnostic query-key factory for TanStack Query caches.
 * Shared so the client app and plugin client panels read/invalidate the SAME
 * cache entries (e.g. launches fetched by both the launch dashboard and the
 * launch-schedule panel dedupe to one request). Never inline key arrays.
 */
export const queryKeys = {
  config: ['config'] as const,
  geocode: (term: string) => ['geocode', term] as const,
  workspace: {
    orgs: ['workspace', 'orgs'] as const,
    orgTrees: ['workspace', 'org-trees'] as const,
    memberships: ['workspace', 'memberships'] as const,
    config: (unitId: string | null) => ['workspace', 'config', unitId] as const,
    locations: (unitId: string) => ['workspace', 'locations', unitId] as const,
    areas: (unitId: string) => ['workspace', 'areas', unitId] as const,
    members: (unitId: string) => ['workspace', 'members', unitId] as const,
    invites: (unitId: string) => ['workspace', 'invites', unitId] as const,
    launchComplexes: ['workspace', 'launch-complexes'] as const,
  },
  space: {
    satellites: ['space', 'satellites'] as const,
    satelliteProfile: (noradId: number) => ['space', 'satellite', noradId] as const,
    launches: ['space', 'launches'] as const,
    /** Site-scoped upcoming launches — pass site names pre-sorted for a stable key. */
    launchesForSites: (sites: string[]) => ['space', 'launches', 'sites', ...sites] as const,
    launchesPrevious: ['space', 'launches', 'previous'] as const,
    launchStats: ['space', 'launches', 'stats'] as const,
    launchSites: ['space', 'launch-sites'] as const,
    launchLocations: ['space', 'launch-locations'] as const,
    weather: ['space', 'weather'] as const,
  },
  cctv: {
    cameras: ['cctv', 'cameras'] as const,
  },
  tak: {
    cotHistory: (uid: string) => ['tak', 'cot-history', uid] as const,
    echoMissionDetail: (joinCode: string) => ['tak', 'echo-mission-detail', joinCode] as const,
  },
} as const;
